import styled from 'astroturf/react';

// DS2 isn't included in some places this is used
// which causes it to fail to compile, so I hardcoded the breakpoint
const TABLET_BREAKPOINT = 768;

export const SurveyQuestion = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SurveyQuestionPrompt = styled.div`
  margin-bottom: 16px;

  font-family: 'Roboto';
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;

  color: #000000;
`;

export const SubPrompt = styled.div`
  margin-bottom: 16px;

  font-family: 'Roboto';
  font-weight: 400;
  font-size: 18px;

  color: #000000;
`;

export const SurveyAnswersContainer = styled.div<{ multiColumn: boolean }>`
  display: grid;
  row-gap: 8px;

  &.multiColumn {
    grid-template-columns: 1fr;
    column-gap: 8px;

    @media (min-width: ${TABLET_BREAKPOINT}px) {
      grid-template-columns: 1fr 1fr;
    }
  }
`;

export const AnswerContainer = styled.button<{
  highlighted: boolean;
  multiColumn: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;

  position: static;
  width: 100%;
  min-height: 48px;

  background: #ffffff;

  border: 1px solid #dddde2;
  border-radius: 2px;

  &.highlighted {
    border: 2px solid #0849b8;
  }

  &.multiColumn {
    height: 47px;
  }
`;

export const AnswerIcon = styled.img`
  width: 22px;
  max-height: 23px;
  margin-right: 20px;
`;

export const AnswerText = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 14px;

  display: flex;

  color: #000000;
  text-align: left;
`;
